import React, { useMemo } from "react";
import Card from "../../../components/ACS-Dashboard/ACS-Blocks/Card";
import ScrollableContainer from "../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer";
import { getClaimsAccess } from "./claimsAccess";
import { mapKpiSummary } from "./claimsMappers";
import { useClaimsSummary } from "./hooks/useClaimsListData";

const ClaimsOverview = () => {
  const access = useMemo(() => getClaimsAccess(), []);
  const { summary } = useClaimsSummary({
    officeCode: access.officeCodes?.join(",") || access.officeCode,
  });
  const kpis = mapKpiSummary(summary);

  const cardsData = [
    { title: "Open Claims", mainValue: String(kpis.openClaims), buttonText: "View" },
    {
      title: "Pending Payment",
      mainValue: `$${kpis.pendingPayment.toLocaleString(undefined, { minimumFractionDigits: 0 })}`,
      buttonText: "Review",
    },
    {
      title: "Paid — Last 90 Days",
      mainValue: `$${kpis.paidLast90.toLocaleString(undefined, { minimumFractionDigits: 0 })}`,
      buttonText: "Details",
    },
    {
      title: "Avg. Days to Close",
      mainValue: String(kpis.avgDaysToClose),
      buttonText: "Trends",
    },
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="scroll-snap-align-start"
              style={{
                minWidth: "clamp(12rem,30cqw,11rem)",
                flex: "0 0 auto",
              }}
            >
              <Card
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default ClaimsOverview;
